import { Enums } from '@bode-canada/core';
import { StyleSizeType } from '@/ui-kit/styles/enums';
import { CAROUSEL_SPACE_MAP } from '@/ui-kit/components/carousel/constants';

const { BuildingTypeEnum, BuildingClassEnum } = Enums;

export const ComparableBuildingTypeMap = {
  [BuildingTypeEnum.HOUSE]: BuildingClassEnum.DETACHED,
  [BuildingTypeEnum.ACREAGE]: BuildingClassEnum.DETACHED,
  [BuildingTypeEnum.LOW_RISE_APARTMENT]: BuildingTypeEnum.LOW_RISE_APARTMENT,
  [BuildingTypeEnum.HIGH_RISE_APARTMENT]: BuildingTypeEnum.HIGH_RISE_APARTMENT,
  [BuildingTypeEnum.HALF_DUPLEX]: BuildingClassEnum.SEMI_DETACHED,
  [BuildingTypeEnum.DUPLEX]: BuildingClassEnum.SEMI_DETACHED,
  [BuildingTypeEnum.FOURPLEX]: BuildingClassEnum.ROW_TOWNHOUSE,
  [BuildingTypeEnum.TRIPLEX]: BuildingClassEnum.ROW_TOWNHOUSE,
  [BuildingTypeEnum.VACANT_LAND]: BuildingClassEnum.VACANT_LAND,
};
export const CAROUSEL_BREAKPOINTS = {
  [StyleSizeType.XSmall]: {
    slidesPerView: 1,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Large],
  },
  [StyleSizeType.Small]: {
    slidesPerView: 2,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Large],
  },
  [StyleSizeType.Medium]: {
    slidesPerView: 3,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Large],
  },
  [StyleSizeType.Large]: {
    slidesPerView: 3,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.XLarge],
  },
  [StyleSizeType.XLarge]: {
    slidesPerView: 3,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.XXLarge],
  },
};
